<script lang="ts" setup>
// Properties
const props = defineProps({
    size: {
        type: String,
        default: "text-2xl md:text-3xl",
    },
    lineHeight: {
        type: String,
        default: "md:leading-h2",
    },
});

// Data
</script>

<template>
    <h2 class="font-bold" :class="size + ' ' + lineHeight">
        <slot></slot>
    </h2>
</template>

<style scoped></style>
